export const environment = {
  production: false,
  apiUrl: 'https://tlbilling.geolink.pt/api'

};
